import React, {createContext} from 'react'


export const AgentContext = createContext({})
